import PropTypes from 'prop-types';
import { Modal } from 'jl-design-system/components/modal/Modal';
export const WarningModal = ({ backToEdit, restoreAppointmentDraft }) => (
  <Modal
    isOpen
    title="Changes not saved"
    onClose={backToEdit}
    rootId="page-root"
    footerLayout="inline"
    primaryButtonText="Yes, cancel"
    underlinedButtonText="No, keep appointment"
    onPrimaryButtonClick={restoreAppointmentDraft}
    onUnderlinedButtonClick={backToEdit}
  >
    <div id="modal-window">
      <p>You&#39;ve not saved your changes.</p>
      <p>Any changes to your appointment will not be updated. Do you want to continue?</p>
    </div>
  </Modal>
);

WarningModal.propTypes = {
  backToEdit: PropTypes.func.isRequired,
  restoreAppointmentDraft: PropTypes.func.isRequired,
};
